export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-numeric characters
  const cleaned = phoneNumber?.replace(/\D/g, "");

  // Match and format as (XXX) XXX-XXXX
  const match = cleaned?.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  // Return original input if it can't be formatted
  return phoneNumber || "";
};

// Strip to bare digits, capped at 10 — the form value validation expects (^\d{10}$).
export const normalizeContactNumber = (
  value?: string | number | null
): string => String(value ?? "").replace(/\D/g, "").slice(0, 10);

